import type { FC } from "react";

import classNames from "classnames";

import { i18nFilter } from "app/filters/i18nFilter";

import { WebsiteTooltip } from "../../Tooltip/WebsiteTooltip/WebsiteTooltip";
import type { ITableCellProps } from "../interfaces/ITableCellProps";
import { trackEvent } from "../SWReactTableTrackEvent";

import { QualificationSideBarCellButton } from "./QualificationSideBarCellButton";
import { UpgradeLink } from "./UpgradeLink";

interface IIndustryTrafficSourceCellProps extends ITableCellProps {
    handleOpenQualificationSideBar?: (row: any) => void;
    onCellClick?: (e: FixmeType, index: number, isEnrichedRowTriggerClick?: boolean) => void;
}

export const IndustryTrafficSource: FC<IIndustryTrafficSourceCellProps> = ({
    value,
    row,
    tableMetadata,
    toggleChildRows,
    showMoreChildRows,
    visibleParents,
    tableOptions,
    groupable,
    handleOpenQualificationSideBar,
    onCellClick,
}) => {
    const children = row.Children || [],
        isChild = row.parent,
        isExpanded = visibleParents
            ? (visibleParents as FixmeType)[row.index] && (visibleParents as FixmeType)[row.index].expanded
            : false,
        showMore = isChild && row.isLast && row.index + 1 !== row.parent.childsCount,
        showMoreStyle = showMore ? { position: "relative" as "absolute", top: "-6px" } : {},
        style = Object.assign({}, showMoreStyle, {
            marginLeft: children.length && groupable ? "19px" : "",
        }),
        classes = classNames("swTable-rowToggle", isExpanded ? "sw-icon-collapse" : "sw-icon-expand"),
        favicon = row.Icon || row.Favicon;

    return value === "grid.upgrade" ? (
        <UpgradeLink hookType="website" />
    ) : (
        <>
            <div className="cell-content">
                {children.length && groupable ? (
                    <i
                        className={classes}
                        onClick={(e) => toggleChildRows(row, value)}
                        style={{ left: "0px" }}
                    ></i>
                ) : null}
                {row.SourceType === "Referral" || row.SourceType === "Display Ad" ? (
                    <span style={style}>
                        <img
                            src={favicon}
                            className="favicon"
                        />
                        <WebsiteTooltip
                            domain={value}
                            handleOpenQualificationSideBar={
                                handleOpenQualificationSideBar
                                    ? (e) => {
                                          if (typeof onCellClick === "function") {
                                              onCellClick(e, -1);
                                          }
                                          handleOpenQualificationSideBar({
                                              Domain: value,
                                              Favicon: favicon,
                                          });
                                      }
                                    : undefined
                            }
                        >
                            <a
                                href={row.url}
                                style={{ paddingLeft: "4px" }}
                            >
                                <div
                                    className={children.length ? "swTable-content-small" : "swTable-content-large"}
                                    onClick={(e) => trackEvent(tableOptions, "Internal Link", value, "click")}
                                >
                                    {value}
                                </div>
                            </a>
                        </WebsiteTooltip>
                        {children.length ? <span className="u-vAlignMiddle">({children.length})</span> : null}
                        <a
                            className="swTable-linkOut sw-link-out"
                            href={`http://${value}`}
                            onClick={() => {
                                trackEvent(tableOptions, "External Link", value, "click");
                            }}
                            target="_blank"
                        ></a>
                    </span>
                ) : (
                    <span>
                        <img
                            src={favicon}
                            className="favicon"
                            style={{ marginRight: "4px" }}
                        />
                        {value}
                    </span>
                )}
                {showMore ? (
                    <button
                        className="swTable-showMore showMore-margin"
                        onClick={(e) => showMoreChildRows(row, value)}
                    >
                        {i18nFilter()("grid.showmore")}
                    </button>
                ) : null}
            </div>
            {(row.SourceType === "Referral" || row.SourceType === "Display Ad") && !!handleOpenQualificationSideBar ? (
                <QualificationSideBarCellButton
                    domain={value}
                    favicon={favicon}
                    handleOpenQualificationSideBar={handleOpenQualificationSideBar}
                />
            ) : null}
        </>
    );
};
IndustryTrafficSource.displayName = "IndustryTrafficSource";
